var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewRecurenceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1412_47719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4681 2.06921C14.1458 2.03982 13.8608 2.27728 13.8314 2.59954L13.7538 3.45117C12.4366 1.38264 10.1501 0 7.50086 0C4.65083 0 2.13918 1.62662 0.892364 4.06799C0.745177 4.35618 0.859493 4.70912 1.14769 4.85631C1.43594 5.0035 1.78882 4.88921 1.93601 4.60099C2.99119 2.53485 5.11015 1.17188 7.50086 1.17188C9.67987 1.17188 11.6463 2.30657 12.7729 4.08422L11.9375 3.48753C11.6741 3.29947 11.3082 3.36047 11.1201 3.62379C10.9321 3.88714 10.993 4.25306 11.2564 4.44114L13.7898 6.25055C14.1611 6.51524 14.6733 6.27293 14.7139 5.82694L14.9984 2.70595C15.0278 2.38365 14.7904 2.09859 14.4681 2.06921Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8531 10.1443C13.5649 9.99714 13.212 10.1114 13.0648 10.3996C12.0096 12.4658 9.89068 13.8287 7.49997 13.8287C5.32095 13.8287 3.35449 12.694 2.22791 10.9164L3.06337 11.5131C3.32672 11.7011 3.69263 11.6401 3.88072 11.3768C4.06878 11.1135 4.00778 10.7475 3.74446 10.5595L1.21101 8.75006C0.844245 8.48803 0.327976 8.72307 0.28696 9.17366L0.00245823 12.2947C-0.0269265 12.6169 0.210525 12.902 0.532761 12.9314C0.855437 12.9607 1.14011 12.723 1.16947 12.401L1.24711 11.5494C2.56424 13.618 4.85068 15.0006 7.49997 15.0006C10.35 15.0006 12.8616 13.374 14.1085 10.9326C14.2557 10.6444 14.1413 10.2915 13.8531 10.1443Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1412_47719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRecurenceIcon);
export default __webpack_public_path__ + "static/media/NewRecurenceIcon.b280a12771b98edb6ae49ab33cf755d3.svg";
export { ForwardRef as ReactComponent };